import { getSizedImageURL } from '../../core/images';
import { updateWishlistButton } from '../../sections/product-page/selectVariant';

const addProductImageToStickyAddToCart = () => {
  // Make sure we can now select a size only if at least one of them is available
  if ($('[data-product-option-sizes] [data-product-option-size].disabled').length < $('[data-product-option-sizes] [data-product-option-size]').length) {
    $('[data-desktop-sticky-add-to-cart-sizes]').addClass('active');
  }

  // Update the thumbnail to the correct color
  const $variant_images = $('[data-product-thumbs] [data-product-thumb]');
  if ($variant_images.length) {
    let new_image_src = $variant_images.first().find('img').attr('src');
    new_image_src = getSizedImageURL(new_image_src, '40x60_crop_center', true);
    // console.log('sticky add to cart image: ', new_image_src);
    
    $('[data-desktop-sticky-add-to-cart-image] img').attr('src', new_image_src);
  }
};

const displayFitColorsStickyAddToCart = () => {
  const selected_fit = $('[data-desktop-sticky-add-to-cart-fit].active').data('fit-handle');
  $('[data-product-option-color-desktop-sticky]').parent().removeClass('active');
  $('[data-desktop-sticky-add-to-cart-colors] [data-index="0"]').addClass('active');
  $(`[data-product-option-color-desktop-sticky][data-plus-color="${(selected_fit === 'plus')}"]`).parent().addClass('active');
  $('[data-desktop-sticky-add-to-cart-colors] ul').selectric('refresh');
};

const displayFitSizesStickyAddToCart = () => {
  const selected_fit = $('[data-desktop-sticky-add-to-cart-fit].active').data('fit-handle');
  $('[data-product-option-size-desktop-sticky]').parent().removeClass('active');
  $('[data-desktop-sticky-add-to-cart-sizes] [data-index="0"]').addClass('active');
  $(`[data-product-option-size-desktop-sticky][data-plus-size="${(selected_fit === 'plus')}"]`).parent().addClass('active');
  $('[data-desktop-sticky-add-to-cart-sizes] ul').selectric('refresh');
};

const refreshSizesInStickyAddToCart = () => {
  $('[data-desktop-sticky-add-to-cart-sizes] .selectric-scroll li').each((index, size_item) => {
    const $size_option_item = $(size_item).find('[data-product-option-size-desktop-sticky]');
    const size_handle = $size_option_item.data('size-handle');

    const $size_option_item_overview = $(`[data-product-option-sizes] [data-product-option-size][data-size-handle="${size_handle}"]`);

    if ($size_option_item_overview.length) {
      if ($size_option_item_overview.hasClass('disabled')) {
        $size_option_item.parent().addClass('disabled');
        $size_option_item.addClass('disabled');
      } else {
        $size_option_item.parent().removeClass('disabled');
        $size_option_item.removeClass('disabled');
      }

      if ($size_option_item_overview.hasClass('active')) {
        $size_option_item.parent().trigger('click');
      }
    }
  });
};

export default () => {
  $(document).on('click touchend', '[data-desktop-sticky-add-to-cart]', (e) => {
    if (window.theme.breakpoints.current === 'mobile' || window.theme.breakpoints.current === 'tablet') {
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    $('.product-actions [data-add-to-cart]').trigger('click');
  });

  $(document).on('click touchend', '[data-desktop-sticky-add-to-cart-fit]', (e) => {
    const $item = $(e.currentTarget);

    $('[data-desktop-sticky-add-to-cart-fit]').removeClass('active');
    $item.addClass('active');

    const selected_fit = $('[data-desktop-sticky-add-to-cart-fit].active').data('fit-handle');
    $(`[data-product-overview] [data-fit-handle="${selected_fit}"]`).trigger('click');

    displayFitColorsStickyAddToCart();
    displayFitSizesStickyAddToCart();
  });

  // A fit has been selected from the product overview
  document.addEventListener('astr-pdp-fit-selected', () => {
    // console.log('[ASTR] astr-pdp-fit-selected', $('[data-product-option-fit].active').length);
    const $active_product_overview_fit = $('[data-product-option-fit].active');

    if (!$active_product_overview_fit.length) {
      return;
    }

    const selected_fit_handle_overview = $active_product_overview_fit.data('fit-handle');
    const selected_fit_handle_sticky = $('[data-desktop-sticky-add-to-cart-fit].active').data('fit-handle');

    // Prevent entering in a loop
    if (selected_fit_handle_overview === selected_fit_handle_sticky) {
      return;
    }
    
    $(`[data-desktop-sticky-add-to-cart-fit][data-fit-handle="${selected_fit_handle_overview}"]`).trigger('click');
  });

  // A color has been selected from the product overview
  document.addEventListener('astr-pdp-color-selected', () => {
    // console.log('[ASTR] astr-pdp-color-selected', $('[data-product-option-color].active').length);
    const $active_product_overview_swatch = $('[data-product-option-color].active');

    if (!$active_product_overview_swatch.length) {
      return;
    }

    const selected_color_handle = $active_product_overview_swatch.data('color-handle');
    // console.log('selected_color_handle', selected_color_handle);

    $(`[data-desktop-sticky-add-to-cart-colors] [data-product-option-color-desktop-sticky][data-color-handle="${selected_color_handle}"]`).parent().trigger('click');

    // It's safe to get the enabled sizes from the product overview since they have been initilized already
    refreshSizesInStickyAddToCart();

    updateWishlistButton();
  });

  // A size has been selected from the product overview
  document.addEventListener('astr-pdp-size-selected', () => {
    const $active_product_overview_size = $('[data-product-option-size].active');

    if (!$active_product_overview_size.length) {
      return;
    }

    const selected_size_handle = $active_product_overview_size.data('size-handle');
    // console.log('selected_size_handle', selected_size_handle);

    $(`[data-desktop-sticky-add-to-cart-sizes] [data-product-option-size-desktop-sticky][data-size-handle="${selected_size_handle}"]`).parent().trigger('click');
  });

  // Init the dropdowns
  if (typeof $('[data-desktop-sticky-add-to-cart-main] ul').selectric !== 'undefined') {
    $('[data-desktop-sticky-add-to-cart-main] ul').selectric({
      // arrowButtonMarkup: '&lt;b class=&quot;button&quot;&gt;&lt;/b&gt;',
      arrowButtonMarkup: '<b class="button"></b>',
      // Function called plugin has been fully initialized
      onInit: (element) => {
        const option_type = $(element).closest('.selectric-wrapper').parent().hasClass('sticky-add-to-cart__colors') ? 'colors' : 'sizes';
  
        if (option_type !== 'colors') {
          return;
        }
  
        if (!$('[data-product-option-colors].active').length) {
          return;
        }
  
        // Auto-select the color based on the value from the product overview
        const color_handle = $('[data-product-option-colors].active').data('color-handle');
        $(`[data-product-option-color-desktop-sticky][data-color-handle="${color_handle}"]`).trigger('click');
      },
      // Action called when select options change
      onChange: (element) => {
        const option_type = $(element).closest('.selectric-wrapper').parent().hasClass('sticky-add-to-cart__colors') ? 'colors' : 'sizes';
        const $selected_li = $(`[data-desktop-sticky-add-to-cart-${option_type}]`).find('li.selected');
  
        if (option_type === 'colors') {
          $('[data-desktop-sticky-add-to-cart-sizes]').removeClass('active');
          const $swatch = $selected_li.find('[data-product-option-color-desktop-sticky]');
          const color_handle = $swatch.data('color-handle');
    
          // Select the same swatch in the product overview
          const $product_overview_swatch = $(`[data-product-option-color][data-color-handle="${color_handle}"]`);
          if ($product_overview_swatch.length && !$product_overview_swatch.hasClass('active')) {
            // Save a session storage to prevent scrollTop and potential loops
            window.sessionStorage.setItem('sticky-desktop-add-to-cart-color-selected', 1);
            $product_overview_swatch.trigger('click');
          }
  
          window.setTimeout(() => {
            addProductImageToStickyAddToCart();
          }, 250);
        }
  
        if (option_type === 'sizes') {
          if ($selected_li.hasClass('disabled') || !$('[data-desktop-sticky-add-to-cart-sizes]').hasClass('active')) {
            // Reselect the previous option that should always be available from the product overview
            const $active_size_item = $('[data-product-option-sizes]').find('[data-product-option-size].active');
            if ($active_size_item.length) {
              $(`[data-desktop-sticky-add-to-cart-${option_type}] .selectric-scroll li [data-size-handle="${$active_size_item.data('size-handle')}"]`).trigger('click');
              $('[data-desktop-sticky-add-to-cart]').prop('disabled', false);
              return;
            }
  
            $(`[data-desktop-sticky-add-to-cart-${option_type}] .selectric-scroll li`).first().trigger('click');
            $('[data-desktop-sticky-add-to-cart]').prop('disabled', true);
            return;
          }
  
          const $size_item = $selected_li.find('[data-product-option-size-desktop-sticky]');
          const size_handle = $size_item.data('size-handle');
          $('[data-desktop-sticky-add-to-cart]').prop('disabled', false);
  
          // Select the same size in the product overview
          const $product_overview_size = $(`[data-product-option-size][data-size-handle="${size_handle}"]`);
          if ($product_overview_size.length && !$product_overview_size.hasClass('active')) {
            // Save a session storage to prevent potential loops
            window.sessionStorage.setItem('sticky-desktop-add-to-cart-size-selected', 1);
            $product_overview_size.trigger('click');
          }
        }
      },
    });
  }

  // Sticky functionality
  $(window).on('scroll', _.debounce(() => {
    const $satc = $('[data-desktop-sticky-add-to-cart-main]');

    if (!$satc.length) {
      return;
    }

    if (window.innerWidth < 769) {
      $satc.removeClass('sticky');
      $satc.attr('aria-hidden', true);
      return;
    }

    const window_top = $(window).scrollTop();
    const $add_to_cart = $('.product-actions [data-add-to-cart]');
    const header_top = Number($('[data-header]').parent().css('top').replace('px', ''));

    let sticky_top = $('[data-main-nav]').outerHeight(true);
    if (header_top === 0) {
      sticky_top += $('[data-header]').outerHeight(true);
    } else if (header_top > 0) {
      sticky_top += $('[data-header]').outerHeight(true) + header_top;
    }

    if ($('body').hasClass('has-sticky-countdown-banner') || $('body').hasClass('has-sticky-promo-banner')) {
      sticky_top += $('[data-countdown-banner]').outerHeight(true);
    }

    $satc.css({ top: `${sticky_top}px` });

    const previously_sticky = $satc.hasClass('sticky');

    if (window_top > $add_to_cart.offset().top) {
      $satc.addClass('sticky');
      $satc.attr('aria-hidden', false);
    }
    else {
      $satc.removeClass('sticky');
      $satc.attr('aria-hidden', true);
    }

    if ($satc.hasClass('sticky') && !previously_sticky) {
      addProductImageToStickyAddToCart();
    }

    // We want to re-adjust since a lot of things are now sticky and get their position re-calculated
    window.setTimeout(() => {
      $(window).trigger('scroll');
    }, 100);
  }, 1));
};
